import React from 'react';

import { useTimerDisplayBanner } from '~/src/common/components/DeliveryProgressBanner/useTimerDisplayBanner';
import DeliveryProgressBar from '~/src/common/components/DeliveryProgressBar';
import { useNiceModal } from '~/src/common/services/ModalsManager';
import { useRecompute2 } from '~/src/queries/api-ecom/generated/api-ecom';

import styles from './DeliveryProgressBanner.module.scss';

const DeliveryProgressBanner = () => {
  const { visible: isCartModalOpen } = useNiceModal('cart-modal');

  const { data: cart } = useRecompute2();

  const shouldDisplay = useTimerDisplayBanner();

  if (!shouldDisplay || isCartModalOpen) return null;

  const totalAmount = cart?.price?.quotation.net ?? 0;
  const deliveryPricesWithDelta = cart?.delivery?.timeSlot?.deliveryPricesWithDeltas ?? [];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <DeliveryProgressBar
          totalCartAmount={totalAmount}
          deliveryPrices={deliveryPricesWithDelta}
        />
      </div>
    </div>
  );
};

export default DeliveryProgressBanner;
